import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconShare = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M13 10a3 3 0 00-2.08.84L6 8.36A2.2 2.2 0 006 8a2.2 2.2 0 000-.36l5-2.48A3 3 0 1010 3a2.2 2.2 0 000 .36L5 5.84a3 3 0 100 4.32l5 2.48a2.2 2.2 0 000 .36 3 3 0 103-3zm0-8a1 1 0 11-1 1 1 1 0 011-1zM3 9a1 1 0 111-1 1 1 0 01-1 1zm10 5a1 1 0 111-1 1 1 0 01-1 1z' />
        </svg>
    );
};

IconShare.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconShare.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconShare;
